import React from 'react';
import {
  Button,
  designSystemToken,
  Label,
} from '@lightricks/react-design-system';
import useContactSales from '@contentlab/hooks/use-contact-sales';
import AnalyticsService from '@/services/analytics/AnalyticsService';
import {
  CONTENT_STUDIO_PRICING_SOURCES,
  FLOW_NAMES,
} from '@/lib/analytics/analyticsConstants';
import translate from '@/utils/translate';

interface UpgradeButtonProps {
  testID?: string;
  onClick?: (openType: string) => void;
}

function UpgradeButton(props: UpgradeButtonProps) {
  const {testID = 'upgrade-button', onClick} = props;
  const onContactSalesClick = useContactSales({
    flowName: FLOW_NAMES.CONTENT_STUDIO.PRICING,
    interactionLocation: 'header',
  });

  const handleClick = () => {
    AnalyticsService.createFlow(FLOW_NAMES.CONTENT_STUDIO.PRICING, {
      source: CONTENT_STUDIO_PRICING_SOURCES.TOOL_BAR_UPGRADE_BUTTON,
      screen_presentation_id:
        AnalyticsService.getActiveScreenPresented().screen_presentation_id,
    });
    onClick?.('contact-sales');
    onContactSalesClick();
  };

  return (
    <Button
      appearance="brand"
      mode="filled"
      size="small"
      onClick={handleClick}
      data-testid={testID}
      sx={{
        'padding': '8px 16px !important',
        'margin': '0 !important',
        'minHeight': '32px !important',
        'height': '32px !important',
        'lineHeight': 1,
        '&.MuiButton-root': {
          margin: '0 !important',
          padding: '8px 16px !important',
        },
      }}
    >
      <Label size="md" color={designSystemToken('semantic.fg.white')}>
        {translate('Contact Sales')}
      </Label>
    </Button>
  );
}

export default UpgradeButton;
